import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState } from 'react';
import { typedFetch } from '../typedFetch';
import './Initialize.scss';
export const Initialize = ({ appendToErrorLog, }) => {
    const [loading, setLoading] = useState(false);
    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [submitted, setSubmitted] = useState(false);
    // backend here must check if any users actually exist first - must be 0
    const submit = (e) => {
        e.preventDefault();
        if (loading) {
            return;
        }
        setLoading(true);
        typedFetch('initialize', { body: { name, email } })
            .then((result) => {
            if (result.success) {
                setSubmitted(true);
            }
            else {
                appendToErrorLog(`Error: ${result.reason}`);
            }
        })
            .catch((error) => {
            appendToErrorLog(`Unexpected error: ${String(error['message'])}`);
        })
            .finally(() => {
            setLoading(false);
        });
    };
    return submitted ? _jsx("h2", { children: "Check your email to continue with account setup" }) : (_jsxs("form", { className: `initialize${loading ? ' loading' : ''}`, onSubmit: submit, children: [_jsx("h2", { children: "First time set-up" }), _jsx("h3", { children: "No users have been created yet. Submit this form to create your root account. A Google account is required." }), _jsx("input", { required: true, placeholder: "First Last", value: name, onChange: (e) => { setName(e.currentTarget.value); } }), _jsx("input", { required: true, placeholder: "Email", value: email, onChange: (e) => { setEmail(e.currentTarget.value); }, type: "email" }), _jsx("button", { children: "Submit and validate email" })] }));
};
